import React, {Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import './modal.css';


const database=firebase.database();



const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px',
	height                :'100px'
	
  }
};


class Modal_Empleado_Empresa extends Component{
	

	
	constructor(){
		
		super();
		this.state={
			
			isActive:false
	
		};
		
		this.toggleModal=this.toggleModal.bind(this);
		this.handleClick=this.handleClick.bind(this);
	}
	
	
	componentWillMount(){
		
		Modal.setAppElement('body');
		
	}
	
	toggleModal=()=>{
		
		this.setState({
			
			isActive:!this.state.isActive
		})
		
	}

	handleClick=(event)=>{
			
			this.setState({
				
				isActive:!this.state.isActive
			})
			
			event.preventDefault();
	}	
	
	
	
	
	render(){
		
		return(
		
		
			<div className="modal_empleado_empresa">
				
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
						
						<form method="POST" action="" onSubmit={this.handleClick}>
						
							<h3>Agregar Empleado</h3>
							
							<hr/>
				
				
							<div className="form-group">
								<label htmlFor="nombre"></label>
								<input type="text" className="form-control" name="nombre"
								placeholder="Nombre" required autoComplete="off"
								/>
							</div>
							<div className="form-group">
								<label htmlFor="apellido"></label>
								<input type="text" className="form-control" name="apellido"
								placeholder="Apellido" required autoComplete="off"
								/>
							</div>

							<div className="form-group">
								<label htmlFor="correo">Correo</label>
								<input type="text" className="form-control" name="correo"
								placeholder="Correo"  required autoComplete="off"
								/>
							</div>
							
							<div className="form-group">
								<label htmlFor="dui">Dui</label>
								<input type="text" className="form-control" name="dui"
								placeholder="Dui" required autoComplete="off"
								/>
							</div>
							
							<div className="form-group">
								<label htmlFor="numero_empleado">Numero empleado</label>
								<input type="text" className="form-control" name="numero_empleado"
								placeholder="Numero empleado" required autoComplete="off"
								/>
							</div>
							
							
							<div className="form-group">
								<label htmlFor="pasaporte">Pasaporte</label>
								<input type="text" className="form-control" name="pasaporte"
								placeholder="Pasaporte" required autoComplete="off"
								/>
								
							</div>
							
							<div className="form-group">
								<label htmlFor="contrasena">Contraseña</label>
								<input type="text" className="form-control" name="contrasena"
								placeholder="Contraseña" required autoComplete="off"
															
								/>
							</div>
							<div className="form-group">
								<label htmlFor="confirmar-contrasena">Contraseña</label>
								<input type="text" className="form-control" name="confirmar-contrasena"
								placeholder="Contraseña" required autoComplete="off"
															
								/>
							</div>
							
							
							<hr/>
							
							<button className="btn btn-primary buttons" type="submit">Ingresar</button>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}> Cerrar</button>
						</form>
							
				</Modal>
			
				
			</div>
		
		);
		
		
	}
	
}

export default Modal_Empleado_Empresa;




// WEBPACK FOOTER //
// ./src/Components/Empleados_empresa/modal_empleado_empresa.jsx